/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */
import { getOwnPropertyDescriptor, getShadowRootFromHostElement, MapCreate } from '../shared/utils';
import {
  getElementById as documentGetElementById,
  getElementsByName as documentGetElementsByName,
  querySelector as documentQuerySelector,
  querySelectorAll as documentQuerySelectorAll,
} from '../env/document';
import {
  getElementById as kagekiriGetElementById,
  getElementsByName as kagekiriGetElementsByName,
  querySelector as kagekiriQuerySelector,
  querySelectorAll as kagekiriQuerySelectorAll,
} from 'kagekiri';

const activeElementOriginal = getOwnPropertyDescriptor(Document.prototype, 'activeElement')!.get!;

const activeElementDistortion = function (this: Document): Element | null {
  let activeElement = activeElementOriginal.call(this);
  while (activeElement) {
    const sr = getShadowRootFromHostElement(activeElement);
    if (!sr) {
      return activeElement;
    }
    activeElement = sr.activeElement; // it is safe to use the dot notation here
  }
  return activeElement;
};

const getElementByIdDistortion = function getElementById(this: Document, id: string) {
  return kagekiriGetElementById(id, this);
};

const getElementsByNameDistortion = function getElementsByName(this: Document, name: string) {
  return kagekiriGetElementsByName(name, this);
};

const querySelectorDistortion = function querySelector(this: Document, selectors: string) {
  return kagekiriQuerySelector(selectors, this);
};

const querySelectorAllDistortion = function getElementsByName(this: Document, selectors: string) {
  return kagekiriQuerySelectorAll(selectors, this);
};

export default MapCreate([
  [activeElementOriginal, activeElementDistortion],
  [documentGetElementById, getElementByIdDistortion],
  [documentGetElementsByName, getElementsByNameDistortion],
  [documentQuerySelector, querySelectorDistortion],
  [documentQuerySelectorAll, querySelectorAllDistortion],
]);
